import axios from "axios";
import LocalStorage from "../../localStorage";
import {loggedOut} from "../auth";

export const GET_ASSET_TYPE_REQUEST = 'GET_ASSET_TYPE_REQUEST';
export const GET_ASSET_TYPE_SUCCESS = 'GET_ASSET_TYPE_SUCCESS';
export const GET_ASSET_TYPE_FAILURE = 'GET_ASSET_TYPE_FAILURE';

const localStorageService = LocalStorage.getService();

export const getAssetTypeRequest = () => {
    return {type: GET_ASSET_TYPE_REQUEST}
};

export const getAssetTypeSuccess = (asset_type = {}) => {
    return {type: GET_ASSET_TYPE_SUCCESS, asset_type}
};

export const getAssetTypeFailure = (error) => {
    return {type: GET_ASSET_TYPE_FAILURE, error}
};

export const startGetAssetType = () => {
    console.log('Start startGetAssetType');
    let token = localStorageService.getAccessToken();
    return (dispatch) => {
        dispatch(getAssetTypeRequest());
        return axios({
                url: `${process.env.REACT_APP_API_ROOTURL}/asset_type/list?key=${process.env.REACT_APP_SERVICE_ACCOUNT_KEY}`,
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': '*',
                    Authorization: 'Bearer ' + token,
                },
                data: JSON.stringify({}),
            }
        )
            .then(function (response) {
                if (response.status === 200 && response.data !== null) {
                    console.log("Response asset_type search ", response.data);
                    dispatch(getAssetTypeSuccess(response.data));

                }
            })
            .catch(function (error) {
                console.log(error);
                if(error.response.status === 401) dispatch(loggedOut());
                dispatch(getAssetTypeFailure(error));
            });
    };
};
